/** BookingsRosterList — the Bookings tab body (BON-199, extracted BON-490):
 *  one row per booking, or an empty state when there are none. */
import type { RosterBooking } from '../../../../api/workshops';

import { RosterRow } from './RosterRow';

export function BookingsRosterList({ bookings }: { bookings: RosterBooking[] }) {
  if (bookings.length === 0) {
    return (
      <div
        style={{
          fontSize: 12,
          color: 'var(--nb-subtle)',
          padding: '14px 0',
          textAlign: 'center',
        }}
      >
        No bookings yet
      </div>
    );
  }
  return (
    <div style={{ display: 'flex', flexDirection: 'column' }}>
      {bookings.map((b) => (
        <RosterRow key={b.bookingId} booking={b} />
      ))}
    </div>
  );
}
